import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import { Globals } from '../../globals';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';


@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, OnDestroy {
    fm: FormGroup;
    public connect;
    public flags: boolean = true;
    public token: any = {
        addContact: "api/addContact"
    }
    constructor(
        public globals: Globals,
        public fb: FormBuilder,
        public toastr: ToastsManager,
        vcr: ViewContainerRef,
    ) {
        this.toastr.setRootViewContainerRef(vcr);
        this.fm = this.fb.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.pattern(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)]],
            phone: ['', [Validators.pattern(/[0-9\+\-\ ]/)]],
            subject: ['', [Validators.required]],
            message: ['', [Validators.required]],

        })
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "addContact":
                    let type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type)
                    if (res['status'] == 1) {
                        this.fm = this.fb.group({
                            name: [''],
                            email: [''],
                            phone: [''],
                            subject: [''],
                            message: [''],
                        })
                    }
                    break;

                default:
                    break;
            }
        })
    }

    ngOnInit() {
    }
    ngOnDestroy() {
        if (this.connect) {
            this.connect.unsubscribe();
        }
    }
    addContact() {
        if (this.flags) {
            this.flags = !this.flags;
            let data = this.fm.value;
            this.globals.send({ path: this.token.addContact, token: "addContact", data: data });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/contact/contact.component.ts